import JobFunctionSingleSelector from 'app/(new-pages)/components/allSelect/JobFunctionSingleSelect/index.pc'
export default JobFunctionSingleSelector
